import type { LeadValues } from "../../shared/lead";
import { useI18n } from "../i18n/I18nProvider";
import { LeadForm } from "../components/LeadForm";
import { ProjectMedia } from "../components/ProjectMedia";

/**
 * Navy lead band from frames 5:2 and 5:150, matching the reference build:
 * desktop band with 68px vertical and 72px side padding, the media column and
 * the form card sharing the row in the 530:730 ratio of the design, and the form
 * card stretched to the media column height with its rows spread evenly.
 *
 * Mobile: the navy band holds only the form; the media column follows it on the
 * light surface. Both use 18px side and 30px vertical padding.
 * The two columns keep the same left/right sides in both locales because the
 * file does not mirror them; only text inside follows direction.
 */
export function LandingSection({
  onSubmit,
  onBypass,
}: {
  onSubmit: (values: LeadValues) => void;
  onBypass: () => void;
}) {
  const { direction } = useI18n();

  return (
    <div className="bg-surface-2 lg:gradient-navy">
      <div
        dir="ltr"
        className="mx-auto flex w-full max-w-[1440px] flex-col lg:flex-row lg:items-stretch lg:gap-9 lg:px-[72px] lg:py-[68px]"
      >
        <div
          dir={direction}
          className="order-2 px-[18px] py-[30px] lg:order-1 lg:min-w-0 lg:flex-[530_1_0%] lg:p-0 lg:pt-[14px]"
        >
          <ProjectMedia />
        </div>
        <div
          dir={direction}
          data-reveal-load="form"
          className="order-1 px-[18px] py-[30px] max-lg:gradient-navy lg:order-2 lg:flex lg:min-w-0 lg:flex-[730_1_0%] lg:p-0"
        >
          <LeadForm onSubmit={onSubmit} onBypass={onBypass} />
        </div>
      </div>
    </div>
  );
}
